import { results } from "./results"

export const CATEGORIES = [...new Set(results.map((d) => d.category))]

export const RESULT_IDS = results.map((d) => d.resultID).sort((a, b) => a - b)
